module.exports = __webpack_public_path__ + "static/img/image050.2dc55f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image050.png
// module id = oRfx
// module chunks = 1